import type { ErrorHandler } from '@angular/core';
import { inject, Injectable } from '@angular/core';

import { ERROR_NOTIFIER } from '../tokens/app.tokens';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly errorNotifier = inject(ERROR_NOTIFIER);

  handleError(error: unknown): void {
    const message = error instanceof Error ? error.message : 'Unknown error';
    console.error('[GlobalErrorHandler]', message);
    this.errorNotifier.notify(error);
  }
}
